import React from 'react';
import { PawPrint, Heart, Mail, Phone, MapPin, ArrowUp, Code2 } from 'lucide-react';

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const Footer = () => {
  return (
    <footer className="bg-[#1A202C] text-gray-400">
      {/* Top bar */}
      <div className="bg-gradient-to-r from-brand-orange/10 to-brand-teal/10 border-b border-white/5 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <PawPrint className="text-brand-orange" size={22} />
            <p className="text-white font-semibold">PetCares · HQ: Coimbatore, TN · Serving South India</p>
          </div>
          <button
            onClick={() => scrollTo('home')}
            className="flex items-center gap-2 text-brand-teal hover:text-white transition text-sm font-medium"
          >
            Back to top <ArrowUp size={16} />
          </button>
        </div>
      </div>

      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">

          {/* Brand block */}
          <div className="col-span-1 md:col-span-2">
            <button onClick={() => scrollTo('home')} className="flex items-center mb-5">
              <PawPrint className="text-brand-orange mr-2" size={26} />
              <span className="text-xl font-extrabold text-white">
                Pet<span className="text-brand-teal">Cares</span>
              </span>
            </button>
            <p className="text-gray-400 max-w-sm mb-5 leading-relaxed text-sm">
              Headquartered in Coimbatore, Tamil Nadu. PetCares connects pet owners across
              South India with verified local pet shops and licensed veterinarians — available
              24/7 for daily needs and life-saving emergencies.
            </p>
            <div className="flex items-center gap-2 text-gray-500 text-sm mb-6">
              <MapPin size={14} className="text-brand-teal" />
              HQ: Coimbatore, Tamil Nadu · Expanding across South India
            </div>
            <div className="flex gap-3">
              <a href="mailto:support@petcares.in" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-orange transition-colors text-white">
                <Mail size={16} />
              </a>
              <a href="tel:+919842111290" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-orange transition-colors text-white">
                <Phone size={16} />
              </a>
              <button className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-orange transition-colors text-white">
                <MapPin size={16} />
              </button>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-bold mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              <li><button onClick={() => scrollTo('home')} className="hover:text-brand-teal transition">Home</button></li>
              <li><button onClick={() => scrollTo('about')} className="hover:text-brand-teal transition">About PetCares</button></li>
              <li><button onClick={() => scrollTo('petshop')} className="hover:text-brand-teal transition">Pet Shops in Coimbatore</button></li>
              <li><button onClick={() => scrollTo('emergency')} className="text-emergency-red hover:text-red-400 font-medium transition">🚨 Emergency Vet</button></li>
            </ul>
          </div>

          {/* Locations served */}
          <div>
            <h4 className="text-white font-bold mb-5">Cities We Serve</h4>
            <ul className="space-y-2 text-sm leading-relaxed">
              {['Coimbatore (Active)', 'Chennai (Coming Soon)', 'Bengaluru (Coming Soon)', 'Kochi (Coming Soon)', 'Madurai (Coming Soon)', 'Hyderabad (Coming Soon)', 'Trichy (Coming Soon)', 'Coimbatore Suburbs'].map(a => (
                <li key={a} className={`flex items-center gap-1.5 ${a.includes('Active') ? 'text-brand-teal font-semibold' : 'text-gray-500'}`}>
                  <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${a.includes('Active') ? 'bg-brand-teal' : 'bg-gray-600'}`} />
                  {a}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600 gap-4">
          <p>&copy; {new Date().getFullYear()} PetCares. All rights reserved. Coimbatore, Tamil Nadu.</p>
          <p className="flex items-center gap-1.5">
            <Code2 size={13} className="text-brand-teal" />
            Designed &amp; Developed with
            <Heart size={12} className="text-emergency-red mx-0.5" fill="currentColor" />
            by <a href="https://aitechies.in/" target="_blank" rel="noreferrer" className="text-brand-teal font-semibold ml-1 hover:underline">AiTechies</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
